import AppButton from "@/components/UI/AppButton";
import AppPopUp from "@/components/UI/AppPopUp";
import TheSaveButton from "@/components/UI/TheSaveButton";
import TheCreateButton from "@/components/UI/TheCreateButton";
import AppHeaderTitle from "@/components/UI/AppHeaderTitle";
import AppButtonDeny from "@/components/UI/AppButtonDeny";
export default [
  AppButton,
  AppPopUp,
  TheSaveButton,
  TheCreateButton,
  AppHeaderTitle,
  AppButtonDeny,
];
